@if (visible$ | async) { @if (variationOptions$ | async; as variationOptions) { @for (group of variationOptions; track
group) {
<div class="product-variation">
  <div class="form-group">
    <label [for]="uuid + group.id" [id]="uuid + group.id + 'label'" class="col-form-label">{{ group.label }}</label>
    <!-- multiple switch case expressions - https://stackoverflow.com/a/45950368 -->
    @switch (true) { @case (group.attributeType === 'colorCode' || group.attributeType === 'swatchImage') {
    <ish-product-variation-select-swatch [group]="group" (changeOption)="optionChange($event)" />
    } @case ( group.attributeType === 'defaultAndColorCode' || group.attributeType === 'defaultAndSwatchImage' ) {
    <ish-product-variation-select-enhanced
      [group]="group"
      [uuid]="uuid"
      [multipleOptions]="variationOptions.length > 1"
      (changeOption)="optionChange($event)"
    />
    } @default {
    <ish-product-variation-select-default
      [group]="group"
      [uuid]="uuid"
      [multipleOptions]="variationOptions.length > 1"
      (changeOption)="optionChange($event)"
    />
    } }
  </div>
</div>
} } }
